
import React, { Component } from 'react';
import PathContext from "../../context/path";
import styles from './FooterCover.module.sass';

class FooterCover extends Component {
	static contextType = PathContext;
	path = this.context;

	render() {
		
	let textSpan = 'you get the result within 15 minutes';
	let textSpan2 = '99.9% accuracy';
	if(window.innerWidth > 767){
		textSpan = 'you get the result within 15 minutes';
		textSpan2 = '99.9% accuracy';
	}
		return (
			<>
				<div className={styles.wrap}>
					<div className={styles.body}>
						<div className={styles.img}>
							<picture>
								<source media="(min-width: 768px)" srcSet={`${this.path}/img/footer-cover-desktop.png`} />
								<img src={`${this.path}/img/footer-cover.png`} alt="" loading="lazy"/>
							</picture>
						</div>
						<h3 className={styles.title}  data-aos="fade-up">There are different tests, but the most convenient is
						<span className={styles.label}>the express test.</span></h3>
						
						<div className={styles.props}  data-aos="fade-up">
							<div className={styles.prop}>
								<span>Fast</span>
								<span>{textSpan}</span>
							</div>
							<div className={styles.prop}>
								<span>Anonymous</span>
								<span>you can buy it at a chemist’s or online store or take it for free at an NGO</span>
							</div>
							<div className={styles.prop}>
								<span>Precision</span>
								<span>{textSpan2}</span>
							</div>

						</div>

					</div>
					<div className={styles.footer}>
						<div className={styles.text}>Take the test and take care of your nearest and dearest.</div>
						<div className={styles.links}>
						<a href='https://spid.center/ru/test/' className={styles.link}>
							{/* <span className={styles.preicon}><img src={`${this.path}/img/icon-link.svg`} alt="" /></span>  */}
							<span>Moscow, Saint Petersburg, Nizhniy Novgorod <span className={styles.posticon}> <img src={`${this.path}/img/icon-post-link.svg`} alt="" /></span> </span></a>
						<a href='https://human.org.ru/resource-center/hivngos/' className={styles.link}>
							{/* <span className={styles.preicon}><img src={`${this.path}/img/icon-link.svg`} alt="" /></span>  */}
							<span>In other cities of Russia <span className={styles.posticon}> <img src={`${this.path}/img/icon-post-link.svg`} alt="" /></span> </span></a>
					</div>
					</div>
				</div>

			</>
		);
	}
}

export default FooterCover;
